import React from 'react';
import '../styles/Header.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserMenu from './UserMenu.tsx';

const TopPanel = ({ onLogout, username, onShowBusinessCard, onShowAside, onShowProfile }) => {
  return (
    <div className="app-header top-panel-custom w-100 d-flex justify-content-between align-items-center px-0 my-2">
      <button
        className="btn btn-light btn-icon mb-0 me-2"
        onClick={onShowAside}
      >
        <i className="bi bi-list"></i>
      </button>

      <UserMenu
        placement="top"
        username={username}
        onLogout={onLogout}
        onShowBusinessCard={onShowBusinessCard}
        onShowProfile={onShowProfile}
      />
    </div>
  );
};

export default TopPanel;
